(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('JobTitleSearch', JobTitleSearch);

    JobTitleSearch.$inject = ['$resource'];

    function JobTitleSearch($resource) {
        var resourceUrl =  'api/_search/job-titles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
